import { Component, OnInit, OnDestroy, HostListener, TemplateRef } from '@angular/core';
import { Observable, of, Subscription } from 'rxjs';
import { SidebarService, ISidebar } from '../sidebar/sidebar.service';
import { ActivatedRoute, DetachedRouteHandle, Router } from '@angular/router';
import { LangService, Language } from 'src/app/shared/lang.service';
import { AuthService } from 'src/app/shared/auth.service';
import { environment } from 'src/environments/environment';
import { Usuario } from 'src/app/models/usuario';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireDatabase, AngularFireList, AngularFireObject } from '@angular/fire/database';
import { Notificacion } from 'src/app/models/notificaciones/notificacion';
import { UsuarioService } from 'src/app/shared/usuario.service';
import { UsuariosService } from 'src/app/data/usuarios.service';
import { Vistas } from 'src/app/models/vistas/vistas';
import * as $ from 'jquery';
import { NotificationsService, NotificationType } from 'angular2-notifications';
import { PermisoModulos } from 'src/app/models/permisoModulo/permisoModulo';
import { PermisosModulosService } from 'src/app/shared/permisosModulo.service';
import { catchError, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-topnav',
  templateUrl: './topnav.component.html',
  styleUrls: ['./topnav.component.scss']
})
export class TopnavComponent implements OnInit, OnDestroy {
  sidebar: ISidebar;
  subscription: Subscription;
  displayName = '';
  tipoPerfil = '';
  id: number;
  avatar = '';
  languages: Language[];
  currentLanguage: string;
  isSingleLang;
  isFullScreen = false;
  isDarkModeActive = false;
  searchKey = '';
  usuarioLogeado: Usuario;
  modalRef: BsModalRef;
  modalRefSoporte: BsModalRef;
  numbers: [] = Array.apply(null, { length: 20 }).map(Number.call, Number)
  tutorialsRef: AngularFireList<any>;
  iconosNotificaciones = environment.iconosNotificaciones;
  // notificaciones = [];
  vistas = new Vistas();
  loadingNotificaciones: boolean = false;
  perfilesParseados = environment.perfilesParseo;
  permisoModuloPerfilamiento = new PermisoModulos();
  permisoModuloModulosReda = new PermisoModulos();

  tipoAcceso: number = 0;
  version: number = 0;
  defaultImage = 'https://www.reda.mx/recursos/usuarios/0.png';

  constructor(private sidebarService: SidebarService,
    private authService: AuthService, public usuarioSevicio: UsuariosService,
    public usuariologin: UsuarioService,
    private router: Router, private modalService: BsModalService,
    private db: AngularFireDatabase,
    private langService: LangService,
    public permisoModuloService: PermisosModulosService,
    private http: HttpClient,
  ) {
    this.languages = this.langService.supportedLanguages;
    this.currentLanguage = this.langService.languageShorthand;
    this.isSingleLang = this.langService.isSingleLang;
    this.isDarkModeActive = this.getColor().indexOf('dark') > -1 ? true : false;
    this.usuarioLogeado = this.usuariologin?.actual;

    // this.tipoAcceso = this.usuariologin.actual.tp;
  }

  onDarkModeChange(event) {
    let color = this.getColor();
    if (color.indexOf('dark') > -1) {
      color = color.replace('dark', 'light');
    } else if (color.indexOf('light') > -1) {
      color = color.replace('light', 'dark');
    }
    localStorage.setItem(environment.themeColorStorageKey, color);
    setTimeout(() => {
      window.location.reload();
    }, 200);
  }

  getColor() {
    return localStorage.getItem(environment.themeColorStorageKey)
      ? localStorage.getItem(environment.themeColorStorageKey)
      : environment.defaultColor;
  }

  fullScreenClick() {
    this.isFullScreen = !this.isFullScreen;
    if (this.isFullScreen) {
      document.documentElement.requestFullscreen();
    } else {
      document.exitFullscreen();
    }
  }

  onLanguageChange(lang) {
    this.langService.language = lang.code;
    this.currentLanguage = this.langService.languageShorthand;
  }

  ngOnInit() {
    this.version = Math.floor(Math.random() * 1000000000);
    this.tipoPerfil = this.perfilesParseados[this.usuarioLogeado?.tipo + ',' + this.usuarioLogeado?.tipoRegistro];

    if (this.usuariologin.actual != null) {
      this.tipoAcceso = this.usuariologin.actual.tp;
      this.usuarioLogeado = this.usuariologin.actual;
    }

    this.usuariologin.user$.subscribe((user) => {
      if (user) {
        this.tipoAcceso = user.tp;
        this.usuarioLogeado = user;
        this.verificaImagenExistente("").subscribe(url => {
          this.avatar = url;
        });
      }
    });

    if (this.authService.user) {
      this.displayName = this.authService.user.displayName;
      this.id = Number(this.usuarioLogeado?.idUsuario);

    }

    this.subscription = this.sidebarService.getSidebar().subscribe(
      res => {
        this.sidebar = res;
      },
      err => {
        console.error(`An error occurred: ${err.message}`);
      }
    );

    // this.verificaImagenExistente("").subscribe(url => {
    //   this.avatar = url;
    // });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  menuButtonClick = (e: { stopPropagation: () => void; }, menuClickCount: number, containerClassnames: string) => {
    if (e) { e.stopPropagation(); }

    setTimeout(() => {
      const event = document.createEvent('HTMLEvents');
      event.initEvent('resize', false, false);
      window.dispatchEvent(event);
    }, 350);
  }

  mobileMenuButtonClick = (event: { stopPropagation: () => void; }, containerClassnames: string) => {
    if (event) { event.stopPropagation(); }
    this.sidebarService.clickOnMobileMenu(containerClassnames);
  }

  onSignOut() {
    this.authService.signOut().subscribe(() => {
      localStorage.clear();
      this.router.navigate(['/user/login']).then(() => {
        window.location.reload();
      });
    });
  }

  searchKeyUp(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.search();
    } else if (event.key === 'Escape') {
      const input = document.querySelector('.mobile-view');
      if (input && input.classList) { input.classList.remove('mobile-view'); }
      this.searchKey = '';
    }
  }

  searchAreaClick(event) {
    event.stopPropagation();
  }

  searchClick(event) {
    if (window.innerWidth < environment.menuHiddenBreakpoint) {
      let elem = event.target;
      if (!event.target.classList.contains('search')) {
        if (event.target.parentElement.classList.contains('search')) {
          elem = event.target.parentElement;
        } else if (
          event.target.parentElement.parentElement.classList.contains('search')
        ) {
          elem = event.target.parentElement.parentElement;
        }
      }

      if (elem.classList.contains('mobile-view')) {
        this.search();
        elem.classList.remove('mobile-view');
      } else {
        elem.classList.add('mobile-view');
      }
    } else {
      this.search();
    }
    event.stopPropagation();
  }

  search() {
    if (this.searchKey && this.searchKey.length > 1) {
      this.router.navigate(['/app/pages/miscellaneous/search'], { queryParams: { key: this.searchKey.toLowerCase().trim() } });
      this.searchKey = '';
    }
  }

  @HostListener('document:click', ['$event'])
  handleDocumentClick(event) {
    const input = document.querySelector('.mobile-view');
    if (input && input.classList) { input.classList.remove('mobile-view'); }
    this.searchKey = '';
  }

  //Mostral modal notificaciones
  onModalNotificaciones(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template,
      Object.assign({}, { class: 'modal-right' })
    );
  }

  verModulos() {
    this.router.navigate(['/app/pages/modulos']);
  }

  VerMiembros() {
    this.router.navigate(['/app/pages/miembros']);
  }

  modalSoporteReda(template: TemplateRef<any>) {
    this.modalRefSoporte = this.modalService.show(template,
      Object.assign({},)
    );
  }

  verConfiguracionesGenerales() {
    this.router.navigate(['/app/pages/configuraciones-generales']);
  }

  cerrar() {
    window.location.href = 'https://portal.reda.mx/';
  }

  verificaImagenExistente(usW: any): Observable<string> {
    const version = Math.floor(Math.random() * 1000000000);

    const imgPerfilUrl = 'https://cors-nvyo.onrender.com/' + 'https://www.reda.mx/recursos/usuarios/' + this.usuariologin.actual?.idUsuario + '/' + this.usuariologin.actual?.idUsuario + '.sm.png?version=' + version;

    return this.http.head(imgPerfilUrl, { observe: 'response' }).pipe(
      map(response => {
        return response.status === 200 && +response.headers.get('content-length') > 0 ? ('https://www.reda.mx/recursos/usuarios/' + this.usuariologin.actual?.idUsuario + '/' + this.usuariologin.actual?.idUsuario + '.sm.png?version=' + this.version) : this.defaultImage;
      }),
      catchError(() => of(this.defaultImage))
    );
    // const imgPerfilUrl = 'https://cors-nvyo.onrender.com/' + 'https://www.reda.mx/recursos/usuarios/' + this.usuariologin.actual?.idUsuario + '/' + this.usuariologin.actual?.idUsuario + '.sm.png?version=' + version;

    // return this.checkImageExistence(imgPerfilUrl).pipe(
    //   map(exists => exists ? 'https://www.reda.mx/recursos/usuarios/' + this.usuariologin.actual?.idUsuario + '/' + this.usuariologin.actual?.idUsuario + '.sm.png?version=' + this.version : this.defaultImage),
    //   catchError(() => of(this.defaultImage))
    // );
  }

  checkImageExistence(imageUrl: string): Observable<boolean> {
    return this.http.head(imageUrl, { observe: 'response' }).pipe(
      map(response => response.status === 200 && +response.headers.get('content-length') > 0),
      catchError(() => of(false))
    );
  }


}
